import Request from '@hotmart-org-ca/request'

import Settings from 'common/helpers/settings/.'

Request.register(`${Settings.api.c3po_conversations}/v1`, {
  get: {
    'get.profile': '/contacts/me'
  }
})

Request.register(`${Settings.api.c3po_auth}/v1`, {
  post: {
    'post.auth.anonymous': '/auth/anonymous'
  }
})
